import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts a URL to the appropriate navigation path format.
 * Uses host-based format for https URLs, legacy encoded format for others.
 */
export function urlToNavigationPath(url: string): string {
  try {
    const urlObj = new URL(url);

    // Use new host-based format for https URLs, legacy format for others
    if (urlObj.protocol === 'https:') {
      const path = urlObj.pathname === '/' ? '' : urlObj.pathname;
      const search = urlObj.search || '';
      const hash = urlObj.hash || '';
      return `/${urlObj.hostname}${path}${search}${hash}`;
    } else {
      // Fallback to legacy format for non-https URLs
      return `/${encodeURIComponent(url)}`;
    }
  } catch {
    // Fallback to legacy format if URL parsing fails
    return `/${encodeURIComponent(url)}`;
  }
}
